import React, { useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import Heading from '../../../../components/Heading';
import AffidavitList from './components/AffidavitList';
import UploadIcon from '@mui/icons-material/Upload';
import PrimaryButton from '../../../../components/Button/Button';
import toast from 'react-hot-toast';
import HPDAffidavitIcon from '../../../../styles/svg/hpd-affidavits.svg';
import AddAffidavitModal from './components/AddAffidavitModal';
import './styles.scss';
import { useHPDViolationAffidavits } from '../../../../reactQuery/violations';
import { isAdmin } from '../../../../utils/helpers';

const HPDAffidavits = () => {
  const [openAddModal, setOpenAddModal] = useState(false);
  const { responseData=[], isLoading, isError, refetch } = useHPDViolationAffidavits();
  console.log(responseData);

  const gropedArray = Object.groupBy(responseData,(affidavit)=> affidavit.category);
  const groupedArray = Object.entries(gropedArray).map(([category, obj]) => {
    return {
      category,
      affidavits: Object.entries(
        Object.groupBy(obj, (affidavit) => affidavit.title)
      ).map(([title, arr]) => ({
        title,
        affidavits: arr,
      })),
    };
  });
  console.log(groupedArray);
  // Mock data for contestation affidavits
  const [contestationAffidavits, setContestationAffidavits] = useState([
    { id: 1, order: '616', name: 'Presumed Lead' },
    { id: 2, order: '623', name: 'Turnover Vio' },
    { id: 3, order: '624', name: 'Inconclusive/Presumed Lead' }
  ]);

  // Mock data for lead affidavits
  const [leadAffidavits, setLeadAffidavits] = useState([
    { id: 4, order: '616/617/624' },
    { id: 5, order: '621-622-623-624' }
  ]);

  const handleOpenAddModal = () => {
    setOpenAddModal(true);
  };

  const handleCloseAddModal = () => {
    setOpenAddModal(false);
  };

  const handleAddAffidavitSuccess = () => {
    // In a real app, you would refetch the data from the server
    toast.success('Affidavit added successfully');
    refetch();
  };

  const handleDeleteAffidavit = (id, type) => {
    // Handle deleting an affidavit based on type
    if (type === 'contestation') {
      setContestationAffidavits(prev => prev.filter(item => item.id !== id));
    } else if (type === 'lead') {
      setLeadAffidavits(prev => prev.filter(item => item.id !== id));
    }
  };

  const handlePrintAffidavit = (item) => {
    // Logic to print an affidavit
    toast.success(`Printing affidavit: ${item.order}`);
  };

  return (
    <Container maxWidth="lg">
      <Box className="hpd-affidavits-container">
        <Heading title="HPD Affidavits" icon={HPDAffidavitIcon}>
            {isAdmin() && <PrimaryButton
              variant="contained"
              className="btn-bg-orange"
              onClick={handleOpenAddModal}
              startIcon={<UploadIcon />}
            >
              Add Affidavit
            </PrimaryButton>}
        </Heading>

        <Box className='mt-4'>
          {groupedArray.length > 0 ? (
            groupedArray.map((item) => (
              <AffidavitList
                key={item.category}
                title={item.category}
                items={item.affidavits}
                onDelete={()=> refetch()}
              />
            ))
          ) : (
            <Box 
              sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '200px',
                mt: 3
              }}
            >
              <Typography variant="h6" color="text.secondary">
                HPD Affidavit not found
              </Typography>
            </Box>
          )}
        </Box>

        {/* Add Affidavit Modal */}
        <AddAffidavitModal 
          open={openAddModal}
          handleClose={handleCloseAddModal}
          onSuccess={handleAddAffidavitSuccess}
        />
      </Box>
    </Container>
  );
};

export default HPDAffidavits; 